export const getMonthOptionsFromCreatedAt = (createdAt) => {
  const startDate = new Date(createdAt);
  const endDate = new Date();

  const options = [];

  let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);

  while (current <= endDate) {
    options.push({
      value: `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, "0")}-01`,
      label: current.toLocaleString("default", {
        month: "long",
        year: "numeric",
      }),
    });

    current.setMonth(current.getMonth() + 1);
  }

  return options;
};
